import { Polyline, CircleMarker, Tooltip } from 'react-leaflet';
import type { Stop } from '../lib/types';

interface RouteOverlayProps {
  stops: Stop[];
  highlightStopId?: string | null;
}

export function RouteOverlay({ stops, highlightStopId }: RouteOverlayProps) {
  if (!stops.length) return null;

  const positions: [number, number][] = stops.map((s) => [
    s.latitude,
    s.longitude,
  ]);

  return (
    <>
      {/* Route polyline */}
      <Polyline
        positions={positions}
        pathOptions={{
          color: '#4a90d9',
          weight: 4,
          opacity: 0.7,
          dashArray: '10, 6',
        }}
      />

      {/* Stop markers */}
      {stops.map((stop) => {
        const isHighlighted = stop.id === highlightStopId;
        return (
          <CircleMarker
            key={stop.id}
            center={[stop.latitude, stop.longitude]}
            radius={isHighlighted ? 10 : 6}
            pathOptions={{
              color: isHighlighted ? '#e94560' : '#4a90d9',
              fillColor: isHighlighted ? '#e94560' : '#fff',
              fillOpacity: 1,
              weight: 2,
            }}
          >
            <Tooltip direction="top" offset={[0, -10]} permanent={isHighlighted}>
              <span style={{ fontWeight: isHighlighted ? 'bold' : 'normal' }}>
                {stop.name}
                {stop.estimated_time && ` (${stop.estimated_time})`}
              </span>
            </Tooltip>
          </CircleMarker>
        );
      })}
    </>
  );
}
